import { useEffect, useState } from "react";
import { getStats } from "./clubApi";
import { Card, inputCls } from "./ui";

const COLS = [["test", "Test"], ["confermati", "Percorsi confermati"], ["check", "Check ricevuti"], ["riordini", "Riordini previsti"]];
const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const lastMonths = () => {
  const now = new Date();
  return Array.from({ length: 24 }, (_, i) => {
    const dt = new Date(now.getFullYear(), now.getMonth() - i, 1);
    return [`${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}`, `${MESI[dt.getMonth()]} ${dt.getFullYear()}`];
  });
};

export default function StatsTab() {
  const [opts] = useState(lastMonths);
  const [mese, setMese] = useState(opts[0][0]);
  const [d, setD] = useState(null);
  useEffect(() => { getStats(mese).then(setD).catch(() => setD(null)); }, [mese]);
  return (
    <div className="mt-6 space-y-4" data-testid="stats-tab">
      <div className="flex items-center justify-between gap-3">
        <p className="font-semibold">Statistiche del mese</p>
        <select className={`${inputCls} w-48 py-2 text-sm`} value={mese} onChange={(e) => setMese(e.target.value)} data-testid="stats-month">
          {opts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
      {d && (
        <>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-testid="stats-totals">
            {COLS.map(([k, l]) => (
              <Card key={k} className="p-4"><p className="font-club-display text-3xl text-[#E5B13A]" data-testid={`stats-total-${k}`}>{d.totale[k]}</p><p className="mt-1 text-xs text-[#9A948A]">{l}</p></Card>
            ))}
          </div>
          <Card className="p-0 overflow-x-auto">
            <table className="w-full text-sm" data-testid="stats-table">
              <thead><tr className="text-left text-[0.65rem] uppercase tracking-[0.15em] text-[#9A948A]"><th className="p-3">Incaricata</th>{COLS.map(([k, l]) => <th key={k} className="p-3 text-right whitespace-nowrap">{l}</th>)}</tr></thead>
              <tbody>
                {d.righe.map((r) => (
                  <tr key={r.user_id} className="border-t border-[#232328]" data-testid={`stats-row-${r.user_id}`}>
                    <td className="p-3 whitespace-nowrap">{r.nome}</td>
                    {COLS.map(([k]) => <td key={k} className="p-3 text-right font-club-display text-base">{r[k]}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
          <p className="text-xs text-[#6F6A62] leading-relaxed">Test: clienti che hanno fatto il test nel mese. Percorsi confermati: percorsi confermati (o modificati per ultimo) nel mese. Check ricevuti: check fatti dai clienti. Riordini previsti: prodotti che, secondo la durata, finiscono nel mese.</p>
        </>
      )}
    </div>
  );
}
